module.exports = {
  /* Default border radius value. */
  borderRadiusLv0: "0",
  borderRadiusLv1: "2px",
  /* Border radius for badge, tags and inputs. */
  borderRadiusLv2: "4px",
  /* Border radius for menus, popovers, table and accordions. */
  borderRadiusLv3: "8px",
  /* Border radius for card and modals. */
  borderRadiusLv4: "12px",
  /* Border radius for buttons. */
  borderRadiusLv5: "38px",
  /* Border radius for avatars. */
  borderRadiusLv6: "50px",
  /* Cavendish Yellow is an energetic brand expression building recognition in moments when our voice must be clear and memorable. We anchor on a single color, used with purpose, to drive consistency across all properties. */
  brandCavendish: "#ffe01b",
  /* This is a Functional color and is used primarily on the website as elements like text, background colors, and dividers. */
  brandPeppercorn: "#241c15",
  /* One of our Functional colors. */
  brandOyster: "#403b3b",
  /* This is a Functional color and is used primarily on the website as elements like text, background colors, and dividers. */
  brandTuna: "#8c8c8c",
  /* One of our Functional colors. */
  brandPortobello: "#b7a9a1",
  /* One of our Functional colors. */
  brandBasmati: "#dbd9d2",
  /* Parsnip is a Functional color and is used as a background color to indicate 'unfilled' space. Use it to indicate the possible breadth of a value. */
  brandParsnip: "#efeeea",
  /* One of our Functional colors. */
  brandJasmine: "#f6f6f4",
  /* This is a Functional color and is used primarily on the website as elements like text, background colors, and dividers. */
  brandCoconut: "#ffffff",
  /* Kale is our primary active state color (interactive color). It is intended to be used as our primary call-to-action color and inspire our users to take an action. */
  brandKale: "#007c89",
  /* Light Kale variation used on dark backgrounds. */
  brandKaleLight: "#4bc4c2",
  /* Dark Kale variation used on light backgrounds that are not Coconut. */
  brandKaleDark: "#004e56",
  /* This is a Background color of our brand and is intended to be used as backgrounds in more expressive brand moments. */
  brandRadish: "#f9e0fa",
  /* This is a Background color of our brand and is intended to be used as backgrounds in more expressive brand moments. */
  brandCucumber: "#d8eacc",
  /* This is a Background color of our brand and is intended to be used as backgrounds in more expressive brand moments. */
  brandCornflower: "#c5dbf2",
  /* This is a Background color of our brand and is intended to be used as backgrounds in more expressive brand moments. */
  brandSquash: "#fbeeca",
  /* This is a Background color of our brand and is intended to be used as backgrounds in more expressive brand moments. */
  brandYam: "#fbcfbd",
  /* Pumpkin is an Accent color that can carry a negative connotation. Use pumpkin sparingly, and as an accent to help when at-a-glance comparisons are needed. Avoid using Pumpkin as the primary color when surfacing negative values in graphs and charts. */
  brandPumpkin: "#f25f25",
  /* This is a darker variation of our Pumpkin to meet color contrast needs. */
  brandPumpkinAccessible: "#a73205",
  /* Apricot is an Accent color that represents itself as neutral. As such, use it for things that do not convey strong positive or negative values. Keep in mind that a similar color, Squash, often represents a 'warning' state. When using Apricot, ensure the association with a warning state isn't too strong. */
  brandApricot: "#e7b75f",
  /* This is a darker variation of our Apricot to meet color contrast needs. */
  brandApricotAccessible: "#d99536",
  /* Apple is an Accent color that is typically used to convey ‘positive’ values or success. It should not be used for conveying a progression. This includes things like representing completion of account setup, percentage of available sends or seats, etc. */
  brandApple: "#00c14e",
  /* This is a darker variation of our Apple to meet color contrast needs. */
  brandAppleAccessible: "#008547",
  /* Plum is an Accent color that represents itself as neutral. As such, use it for things that do not convey strong positive or negative values. */
  brandPlum: "#692340",
  /* Dragonfruit is an Accent color and should be used to add visual interest. That said, it should never overwhelm the composition through the use of too many at once. Seasonal campaigns may use lead colors other than yellow. */
  brandDragonfruit: "#ff3ebf",
  brandPeppercorn65: "rgba(36,28,21,0.65)",
  brandPeppercorn30: "rgba(36,28,21,0.3)",
  brandPeppercorn15: "rgba(36,28,21,0.15)",
  brandCoconut50: "rgba(255,255,255,0.5)",
  brandCoconut20: "rgba(255,255,255,0.2)",
  brandCoconut10: "rgba(255,255,255,0.1)",
  dataVizCombo1Color1: "#f97f50",
  dataVizCombo1Color2: "#4f135e",
  dataVizCombo1Color3: "#99c7ef",
  dataVizCombo1Color4: "#fad173",
  dataVizCombo1Color5: "#a3296e",
  dataVizCombo2Color1: "#fad173",
  dataVizCombo2Color2: "#99c7ef",
  dataVizCombo2Color3: "#de4d14",
  dataVizCombo2Color4: "#83249f",
  dataVizCombo2Color5: "#fa8cf8",
  dataVizCombo3Color1: "#fad173",
  dataVizCombo3Color2: "#f97f50",
  dataVizCombo3Color3: "#83249f",
  dataVizCombo3Color4: "#99c7ef",
  dataVizCombo3Color5: "#f73bb9",
  dataVizCombo4Color1: "#83249f",
  dataVizCombo4Color2: "#f97f50",
  dataVizCombo4Color3: "#fad173",
  dataVizCombo4Color4: "#99e0d7",
  dataVizCombo4Color5: "#4277ce",
  dataVizCombo5Color1: "#4bc4c2",
  dataVizCombo5Color2: "#fad173",
  dataVizCombo5Color3: "#f97f50",
  dataVizCombo5Color4: "#83249f",
  dataVizCombo5Color5: "#fa8cf8",
  dataVizCombo6Color1: "#d99536",
  dataVizCombo6Color2: "#99c7ef",
  dataVizCombo6Color3: "#a3296e",
  dataVizCombo6Color4: "#de4d14",
  dataVizCombo6Color5: "#005733",
  /* A visual affordance of height for modals. */
  elevationLvl3: "0px 16px 24px rgba(36, 28, 21, 0.24)",
  /* A visual affordance of height for side view, toasts and notifications. */
  elevationLvl2: "0px 12px 24px rgba(36, 28, 21, 0.16)",
  /* A visual affordance of height for pop-up elements like menus. */
  elevationLvl1: "0px 4px 12px rgba(36, 28, 21, 0.12)",
  /* No elevation. This is typically used for default content. */
  elevationLvl0: "none",
  fontWeightLight: "300",
  fontWeightNormal: "400",
  fontWeightBold: "500",
  /* Used sparingly, no more than once per page. */
  fontSizeH1: "4.8rem",
  /* Typically used for header summaries or for significant data. */
  fontSizeH2: "3.2rem",
  /* This is mostly used in our header bar. */
  fontSizeH3: "2.4rem",
  /* Typically used for page header title or sparingly in components. */
  fontSizeH4: "2rem",
  /* Used for shortform paragraphs denoting specific information. */
  fontSizeLarge: "2rem",
  /* Used for longform paragraphs and descriptive helper copy. */
  fontSizeMedium: "1.6rem",
  /* Used as tags or list kickers/brows. */
  fontSizeSmall: "1.3rem",
  lineHeightText: "1.5",
  lineHeightReset: "1",
  /* Deprecated. Use desktop breakpoint. */
  mqMaxWidth: "90em",
  mqDesktop: "90em",
  /* Deprecated. Use phone or tablet breakpoints to define the max and min points. */
  mqMobile: "60em",
  mqPhone: "37.5em",
  mqTablet: "60em",
  /* We follow a 4px baseline grid for achieving a vertical rhythm in the app. */
  baseUnit: "4px",
  /* A max width that is typically set on body text for optimum reading length. */
  readableMaxWidth: "70ch",
  spacing1: "4px",
  spacing2: "8px",
  spacing3: "12px",
  spacing4: "16px",
  spacing5: "20px",
  spacing6: "24px",
  spacing7: "32px",
  spacing8: "48px",
  spacing9: "72px",
  spacing10: "96px",
  spacing11: "128px",
  /* Default text color. Used for most body copy and paragraphs. */
  textColorPrimary: "#241c15",
  /* Used on text that conveys additional information like input descriptions. */
  textColorSecondary: "rgba(36,28,21,0.65)",
  /* Mostly used on our body text for error messages or destructive actions. */
  textColorError: "#a73205",
  /* Used for our inline links. */
  linkColor: "#007c89",
  /* The color of our link text on hover. */
  linkColorHover: "#004e56",
  /* Our base duration metric. */
  durationBase: "0.2s",
  animationCurve: "cubic-bezier(.8, 0, 0.16, 1)",
  animationSpeedFast: "120ms",
  animationSpeedSlow: "320ms",
  /* Our base metric used for background color transitions. */
  backgroundTransition: "background 0.2s ease-in-out 0s",
  /* Our base metric used for box shadow transitions. */
  boxShadowTransition: "box-shadow 0.2s ease-in-out 0s",
  /* Means is the primary brand typeface for Mailchimp and typically used for headlines. The light weight sets an editorial tone while uncommon rounded corners infuse the typeface with a distinctive personality. */
  typefaceBrand: "\"Means Web\", Georgia, Times, \"Times New Roman\", serif",
  /* Graphik is our workhorse typeface, carefully chosen to support Means in more functional moments. Purposefully plain, this sans-serif prioritizes legibility and balances the expressiveness of Means. */
  typefaceBase: "\"Graphik Web\", \"Helvetica Neue\", Helvetica, Arial, Verdana, sans-serif",
  /* Typically used in code blocks. */
  typefaceMonospace: "\"SFMono-Regular\", Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", Courier, monospace",
  zAuto: "auto",
  zBase: "1",
  /* Used for between base and navigation elements. */
  zHeader: "5",
  /* Used for navigation elements. */
  zNav: "10",
  /* Used for preview pane or educational panel. */
  zPreview: "100",
  /* Used for modals, dialogs or popovers. */
  zModal: "1000",
  /* Used for dinner menus like search fields and notifications. */
  zMenus: "10000",
  /* Used for the reauth dialog. */
  zReauth: "100000",
};